import { Config } from '../config';
import { Vehicle } from '../interfaces';
import { HttpService } from './http.service';

const path = `${Config.API}/vehicles`;

export abstract class VehicleService {
  public static getAll = (): Promise<Vehicle[]> => {
    return HttpService.fetchAuthorized(path).then((res) => {
      if (!res) {
        return [];
      }

      return res;
    });
  };

  public static create = (body: Partial<Vehicle>): Promise<any> => {
    return HttpService.fetchAuthorized(path, {
      method: 'POST',
      body: JSON.stringify(body),
    }).then((res) => res);
  };

  public static get = (id: number): Promise<Vehicle> => {
    return HttpService.fetchAuthorized(`${path}/${id}`).then((res) => res);
  };

  public static update = (id: number, body: Partial<Vehicle>): Promise<any> => {
    return HttpService.fetchAuthorized(`${path}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    }).then((res) => res);
  };

  public static delete = (id: number): Promise<any> => {
    return HttpService.fetchAuthorized(`${path}/${id}`, {
      method: 'DELETE',
    }).then((res) => res);
  };
}
